export default function () {
    return function (input, currentPage, perPage) {

        var start = (currentPage - 1) * perPage,
            end = start + perPage;

        var output = input.where(function (el) {
            return !el.hiddenByProgramFilter && !el.hiddenByLocationFilter && !el.allClassesClosed;
        });

        return (output || []).slice(start, end);
    }
};